import type { Dispatch } from 'redux';
import memoizeOne from 'memoize-one';
import * as R from 'ramda';
import { updatePlan } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/plan';
import { getDateConfiguration } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/plan';
import {
	DATEFIELD_WARNINGS,
	type DateConfiguration,
	type DateFieldTypes,
	type DateFieldWarnings,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/plan/types';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { createStructuredSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import type { MapDispatchToPropsSimple } from '@atlassian/jira-portfolio-3-portfolio/src/common/types/redux';
import type { StateProps } from './types';

export const mapStateToProps = createStructuredSelector<State, StateProps>({
	dateConfiguration: getDateConfiguration,
});

export const mapDispatchToProps: MapDispatchToPropsSimple<{ dispatch: Dispatch }> = (dispatch) => ({
	dispatch,
});

const dateFieldNeedsUpdate = (dateField: DateFieldTypes) => {
	const warning = R.path<DateFieldWarnings['code']>(['warning', 'code'], dateField);

	if (!warning) return false;

	return Object.values(DATEFIELD_WARNINGS).includes(warning);
};

const handleKeepUsingTargetDatesFactory = memoizeOne(
	(dateConfiguration: DateConfiguration, dispatch: Dispatch) => () => {
		// @ts-expect-error - TS2769 - No overload matches this call.
		const payload = R.map(R.omit(['warning']), R.pickBy(dateFieldNeedsUpdate, dateConfiguration));
		dispatch(updatePlan(payload));
	},
);

export const mergeProps = (stateProps: StateProps, dispatchProps: { dispatch: Dispatch }) => {
	const { dispatch } = dispatchProps;
	const { dateConfiguration } = stateProps;

	return {
		handleKeepUsingTargetDates: handleKeepUsingTargetDatesFactory(dateConfiguration, dispatch),
		...stateProps,
	};
};
